import { IAddTeplar } from '../../models/forms/IAddUpdateTeplar';
import { ITeplarVM } from '../../models/response/ITeplarResponse';
const initialTeplarState: IAddTeplar = {
  formFile: null,
};

export const UpdateTeplarState: ITeplarVM = {
  Id: -1,
  Katashiki: '',
  ProductId: '',
  Format: '',
  Layout: 0,
  Width: 0,
  Remarks: '',
  Items: [],
};

export default initialTeplarState;
